<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>律师认证</span>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="lawyer_box"
    v-loading="authenticationLoading"
    element-loading-text="认证信息加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(256, 256, 256, 0.8)">
      <el-steps class="user_authentication_step" :active="stepActive" :process-status="processStatus" finish-status="success">
        <el-step title="实名认证"></el-step>
        <el-step title="填写信息"></el-step>
        <el-step title="审核状态"></el-step>
        <el-step title="审核结果"></el-step>
      </el-steps>
      <!-- 未进行实名认证 -->
      <div v-if="examine.type === 0 && personalReview < 2" class="user_review_box">
        <img src="../../assets/img/authentication/personalReviewNone.png" alt="未实名认证">
        <dl class="user_review_tip">
          <dt>请您先通过实名认证！</dt>
          <dd>
          </dd>
        </dl>
        <button class="my_follow_btn user_review_btn" @click="personalClick()">点击前往</button>
      </div>
      <!-- 填写信息 -->
      <el-form v-if="examine.type === 0 && personalReview === 2" :model="info" :rules="rules" ref="formData" label-width="100px">
        <el-form-item label="真实姓名">
          {{info.card_id_name}}
        </el-form-item>
        <el-form-item label="执业地点" prop="place_practice">
          <div v-show="textOnOff">
            {{info.place_practice}}
          </div>
          <el-input v-show="!textOnOff" v-model="info.place_practice"></el-input>
        </el-form-item>
        <el-form-item label="执业证号" prop="license_num">
          <div v-show="textOnOff">
            {{info.license_num}}
          </div>
          <el-input v-show="!textOnOff" v-model="info.license_num"></el-input>
        </el-form-item>
        <el-form-item label="执业律所" prop="law_firm">
          <div v-show="textOnOff">
            {{info.law_firm}}
          </div>
          <el-input v-show="!textOnOff" v-model="info.law_firm"></el-input>
        </el-form-item>
        <el-form-item v-show="textOnOff" label="执业证照片">
          <dl>
            <dt>
              执业证封面：
              <el-image
                :src="info.cover"
                :preview-src-list="img.arr">
              </el-image>
            </dt>
            <dd>
              执业证照片页：
              <el-image
                :src="info.photo"
                :preview-src-list="img.arr">
              </el-image>
            </dd>
            <dd>
              执业证考核页：
              <el-image
                :src="info.assessment"
                :preview-src-list="img.arr">
              </el-image>
            </dd>
          </dl>
        </el-form-item>
        <el-form-item v-show="!textOnOff" label="执业证照片" :required="true">
          <dl>
            <dt>
              执业证封面：
              <imgUpload :filestype="img.coverType" :imgurl="info.cover" :imgtext="img.coverText" @files="files"></imgUpload>
            </dt>
            <dd>
              执业证照片页：
              <imgUpload :filestype="img.photoType" :imgurl="info.photo" :imgtext="img.photoText" @files="files"></imgUpload>
            </dd>
            <dd>
              执业证考核页：
              <imgUpload :filestype="img.assessmentType" :imgurl="info.assessment" :imgtext="img.assessmentText" @files="files"></imgUpload>
            </dd>
          </dl>
        </el-form-item>
        <el-form-item label="手持律师证" :required="true">
          <div v-show="textOnOff">
            <el-image
              :src="info.handheld_license"
              :preview-src-list="img.arr">
            </el-image>
          </div>
          <imgUpload v-show="!textOnOff" :filestype="img.handheldType" :imgurl="info.handheld_license" :imgtext="img.handheldText" @files="files"></imgUpload>
        </el-form-item>
        <el-form-item>
          <div v-if ="!textOnOff" class="rg_form_box_form_item">
            <el-button v-show="subBtnOnOff" type="primary" class="rg_form_box_form_sub" @click="submitForm('formData')">提交</el-button>
            <el-button v-show="!subBtnOnOff" type="primary" :loading="true">提交中</el-button>
          </div>
        </el-form-item>
      </el-form>
      <!-- 审核中 -->
      <div v-if="examine.type === 1" class="user_review_box">
        <img src="../../assets/img/authentication/lawterReview.png" alt="审核中">
        <dl class="user_review_tip">
          <dt>您提交的律师信息正在审核中...</dt>
          <dd>
            <p>预计一个工作日内完成审核，请耐心等待！</p>
          </dd>
        </dl>
      </div>
      <!-- 审核成功 -->
      <div v-if="examine.type === 2" class="user_review_box">
        <img src="../../assets/img/authentication/lawterReviewSuccess.png" alt="认证通过">
        <dl class="user_review_tip">
          <dt>认证通过！</dt>
          <dd>
          </dd>
        </dl>
      </div>
      <!-- 审核失败 -->
      <div v-if="examine.type === 3" class="user_review_box">
        <img src="../../assets/img/authentication/lawterReviewError.png" alt="认证失败">
        <dl class="user_review_tip">
          <dt>您的律师认证未通过审核！</dt>
          <dd>
            <p class="user_review_name">
              拒绝原因：{{examine.text}}
            </p>
          </dd>
        </dl>
        <button class="my_follow_btn user_review_btn" @click="resetClick()">重新认证</button>
      </div>
    </div>
  </div>
</template>

<script>
import img from '../Public/imgUpload.vue'
export default {
  components: {
    imgUpload: img
  },
  data () {
    return {
      subBtnOnOff: true, // 提交状态
      textOnOff: false, // 是否显示文本
      authenticationLoading: true, // 认证加载动画
      stepActive: 0, // 步骤条当前显示步骤
      processStatus: 'finish', // 当前步骤的状态
      personalReview: 0, // 实名认证是否认证完成
      examine: { // 审核状态
        type: 0,
        text: ''
      },
      info: {
        type: 2,
        card_id_name: '', // 真实姓名
        place_practice: '', // 执业地点
        license_num: '', // 执业证号
        law_firm: '', // 执业律所
        cover: '', // 封面
        photo: '', // 照片
        assessment: '', // 考核也
        license: [], // 执业证照片
        handheld_license: '' // 手持执业证
      },
      img: {
        arr: [],
        coverType: 'cover',
        photoType: 'photo',
        assessmentType: 'assessment',
        handheldType: 'handheld',
        coverText: '请上传执业证封面，大小不超过3M',
        photoText: '请上传执业证照片页，大小不超过3M',
        assessmentText: '请上传执业证考核页，大小不超过3M',
        handheldText: '请上传本人手持律师证，大小不超过3M'
      },
      rules: {
        place_practice: [
          { required: true, message: '请输入执业地点', trigger: 'blur' }
        ],
        license_num: [
          { required: true, message: '请输入执业证号', trigger: 'blur' }
        ],
        law_firm: [
          { required: true, message: '请输入执业律所', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getAuthenticationLog()
  },
  methods: {
    // 获取认证信息
    getAuthenticationLog () {
      const vueThat = this
      vueThat.myApi.getAuthenticationLog({ type: vueThat.info.type }).then((res) => {
        if (res.data.code === 200) {
          vueThat.authenticationLoading = false
          vueThat.personalReview = res.data.data.is_auth
          if (res.data.data.is_auth === 2) { // 实名认证通过
            vueThat.info.card_id_name = res.data.data.nick_name
            const data = res.data.data.data
            if (data === null) {
              vueThat.stepActive = 1
              vueThat.processStatus = 'finish'
              vueThat.textOnOff = false
            } else {
              for (const key in res.data.data.data) {
                vueThat.info[key] = res.data.data.data[key]
              }
              vueThat.examine.type = data.status
              if (vueThat.info.license.length > 0) {
                vueThat.info.cover = vueThat.info.license[0]
                vueThat.info.photo = vueThat.info.license[1]
                vueThat.info.assessment = vueThat.info.license[2]
              }
              vueThat.img.arr = [vueThat.info.cover, vueThat.info.photo, vueThat.info.assessment, vueThat.info.handheld_license]
              switch (data.status) {
                case 1:
                  vueThat.stepActive = 2
                  vueThat.processStatus = 'finish'
                  break
                case 2:
                  vueThat.stepActive = 3
                  vueThat.processStatus = 'success'
                  break
                case 3:
                  vueThat.stepActive = 3
                  vueThat.processStatus = 'error'
                  vueThat.examine.text = data.reason
                  break
              }
            }
          }
        }
      })
    },
    // 文件地址获取
    files (url, type) {
      switch (type) {
        case 'cover':
          this.info.cover = url
          break
        case 'photo':
          this.info.photo = url
          break
        case 'assessment':
          this.info.assessment = url
          break
        case 'handheld':
          this.info.handheld_license = url
          break
      }
    },
    // 提交
    submitForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate((valid) => {
        if (valid) {
          if (vueThat.info.cover === '') {
            vueThat.$message.error('请上传执业证封面！')
          } else if (vueThat.info.photo === '') {
            vueThat.$message.error('请上传执业证照片页！')
          } else if (vueThat.info.assessment === '') {
            vueThat.$message.error('请上传执业证考核页！')
          } else if (vueThat.info.handheld_license === '') {
            vueThat.$message.error('请上传本人手持律师证！')
          } else {
            vueThat.subBtnOnOff = false
            vueThat.info.license = [vueThat.info.cover, vueThat.info.photo, vueThat.info.assessment]
            vueThat.myApi.userRealNameAuthentication(vueThat.info).then((res) => {
              if (res.data.code === 200) {
                vueThat.$alert('提交成功，请等待审核成功！', '温馨提示', {
                  type: 'success',
                  iconClass: 'iconfont icon-icon_richeng_btn_pass',
                  confirmButtonText: '确定',
                  showClose: false,
                  callback: action => {
                    vueThat.textOnOff = true
                    vueThat.examine.type = 1
                    vueThat.stepActive = 2
                    vueThat.processStatus = 'finish'
                  }
                })
              }
            })
          }
        } else {
          vueThat.$message.error('请检查填写项是否正确！')
          return false
        }
      })
    },
    // 跳转实名认证
    personalClick () {
      this.$store.commit('editPersonalMeunAct', 'personalCertification')
      this.$router.push({ path: '/personalCertification' })
    },
    // 重置信息提交申请
    resetClick () {
      const vueThat = this
      vueThat.examine.type = 0
      vueThat.stepActive = 1
      vueThat.processStatus = 'finish'
    }
  }
}
</script>

<style>
</style>
